import { render, staticRenderFns } from "./insertionLayoutEditorTutorial.vue?vue&type=template&id=63d8c45e&"
import script from "./insertionLayoutEditorTutorial.vue?vue&type=script&lang=ts&"
export * from "./insertionLayoutEditorTutorial.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports